import { combineReducers } from 'redux';

import counterReducer from './counter/counter.reducer';
import darkmodeReducer from './darkmode/darkmode.reducer';

const rootReducer = combineReducers({
	counter: counterReducer,
	darkmode: darkmodeReducer
});

export default rootReducer;